import { SxProps, Theme } from '@mui/material';

export const productSkuSx: SxProps<Theme> = {
	alignSelf: 'flex-start',
};

export const typographySx: SxProps<Theme> = {
	color: 'grey.300',
	textAlign: 'left',
	fontSize: '12px',
};
